import PostsSerializer from './base';

export default class Text extends PostsSerializer {
  payloadKeyFromModelName(modelName) {
    return super.payloadKeyFromModelName(modelName).replace('text', 'post');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(key.replace('post', 'text'));
  }
}
